module.exports = __webpack_public_path__ + "img/pic_8.ec822380.png";